import React, { useEffect } from "react";
import {
  ActivityRing,
  getBrokerInfo,
  rings,
  SessionKeys,
  showTourAndGuideUtils,
} from "../../utils/AppUtils";
import { useDispatch, useSelector } from "react-redux";
import HeaderFinwell from "../components/HeaderFinwell";
import SideMenuFinwell from "../components/SideMenuFinwell";
import Page from "./Page";
import { userDetailBroker } from "../../redux/user/actions";
import _ from "lodash";
import HomeBanner from "../components/home/HomeBanner";
import MoneyJourney from "../components/home/MoneyJourney";
import ActivityRingComp from "../components/home/ActivityRingComp";
import ContinueJourney from "../components/home/ContinueJourney";
import ForYou from "../components/home/ForYou";
import { getLoginLogoClear, setShowChangePassword } from "../../redux/home/actions";

const HomeFinwellPage = () => {
  const dispatch = useDispatch();

  const loginLogo = useSelector((state) => state.home.loginLogo);

  useEffect(() => {
    getBrokerInfo(dispatch);
  }, [dispatch]);

  useEffect(() => {
    if (!_.isEmpty(loginLogo)) {
      if (
        loginLogo.status === "success" &&
        !_.isEmpty(loginLogo.payload?.data)
      ) {
        let data = loginLogo.payload.data.sso_response;
        if (data?.is_sso_enabled === "1") {
          dispatch(setShowChangePassword("false"))
        } else {
          dispatch(setShowChangePassword("true"))
        }

        setTimeout(() => {
          dispatch(getLoginLogoClear());
        }, 2000);
      } else {
        setTimeout(() => {
          dispatch(getLoginLogoClear());
        }, 2000);
      }
    }
  }, [loginLogo]);

  useEffect(() => {
    localStorage.removeItem("i18nextLng");
    sessionStorage.removeItem("currentDuration");
    sessionStorage.removeItem("duration")
  }, []);

  return (
    <>
      <Page>
        <main id="main-content" tabIndex="-1">
          <HomeBanner />

          <MoneyJourney />

          <ActivityRingComp />

          <ContinueJourney />
          <div className="fro-you-home">
            <ForYou from = {"home"} selectedContentType={[]} />
          </div>
        </main>
      </Page>
    </>
  );
};

export default HomeFinwellPage;
